.trigger {
    display: inline-flex;
    position: relative;
}

.bubble {
    position: absolute;
    z-index: var(--tempest-z-tooltip);
    background-color: var(--tempest-gray-900);
    color: #ffffff;
    padding: 6px 10px;
    border-radius: var(--tempest-radius-sm);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-xs);
    font-weight: var(--tempest-weight-medium);
    line-height: var(--tempest-leading-snug);
    white-space: nowrap;
    pointer-events: none;
    box-shadow: var(--tempest-shadow-lg);
    animation: tempest-tooltip-in var(--tempest-duration-fast) var(--tempest-ease-out);
}

.top {
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}

.bottom {
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
}

.left {
    right: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
}

.right {
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
}

@keyframes tempest-tooltip-in {
    from {
        opacity: 0;
        transform: scale(0.94) translate(var(--tempest-tx, 0), var(--tempest-ty, 0));
    }
    to {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .bubble {
        animation: none;
    }
}

/* Hide tooltip on touch / no-hover devices — tap+hold leaves
 * tooltip stuck visible and competes with native long-press menus. */
@media (hover: none) {
    .bubble {
        display: none;
    }
}
